import { FC, useCallback } from 'react';
import { StyledSecondaryButton } from '../../styled';
import { firstLetterUppercase } from '../../utils';

export interface SecondaryButtonProps {
  text?: string;
  href?: string;
  onClick: () => void;
}

export const SecondaryButton: FC<SecondaryButtonProps> = ({
  text,
  href,
  onClick,
}) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (href && href !== '') {
        e.preventDefault();
        window.location.href = href;
      }
      onClick();
    },
    [href, onClick],
  );

  const anchorAttrs: Pick<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    'target' | 'rel'
  > = { target: '_self', rel: 'noopener noreferrer' };

  return (
    <StyledSecondaryButton
      component="a"
      href={href}
      variant="primary"
      onClick={handleClick}
      {...anchorAttrs}
    >
      {firstLetterUppercase(text)}
    </StyledSecondaryButton>
  );
};
